import { useMutation } from '@apollo/client';
import { useCartState } from '../contexts/cart';
import MUTATION_REMOVE_ITEM from '../aem-core-components/queries/mutation_remove_item.graphql';
import { removeItemFromCart } from '../aem-core-components/actions/cart';
import { SET_IS_CART_LOADING } from '../aem-core-components/actions/constants';

export default props => {
    const { item } = props;
    const [{ cartId, cart }, dispatch] = useCartState();
    const [removeItemMutation] = useMutation(MUTATION_REMOVE_ITEM);

    const editItem = () => {
        dispatch({ type: 'beginEditing', item: item });
    };

    const removeItem = async itemUid => {
        try {
            dispatch({ type: 'beginLoading' });
            const itemQuantity = await removeItemFromCart({
                cartId,
                itemUid,
                dispatch,
                cart,
                removeItemMutation
            });
            if (!itemQuantity || itemQuantity?.length === 0) {
                dispatch({ type: SET_IS_CART_LOADING, isCartLoading: false });
            }
            dispatch({ type: 'endLoading' });
            return itemQuantity;
        } catch (er) {
            dispatch({ type: SET_IS_CART_LOADING, isCartLoading: false });
            dispatch({ type: 'endLoading' });
        }
    };

    return [{}, { removeItem, editItem }];
};
